<template>
  <a-spin :spinning="loading">
    <a-card :bordered="false">
      <div>
        <a-form :form="form" >
          <a-row>
            <a-col :span="24">
              <a-divider orientation="left">
                合同信息
              </a-divider>
            </a-col>
            <a-col :span="12" v-if="data">
              <a-form-item label="委托方名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['host_corporation'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12" v-if="data">
              <a-form-item label="货物名称" :label-col="labelCol" :wrapper-col="wrapperCol">
                {{ this.data['category'] }}
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="系统编号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-decorator="['number', {rules: [{required: true, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" disabled/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="进出口类型" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  option-label-prop="tt"
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="null"
                  show-search
                  allow-clear
                  v-decorator="[
                    'import_export_type',
                    {
                      rules: [
                        { required: true, message: '' },
                      ],
                    },
                  ]"
                  placeholder="请选择"
                  :default-active-first-option="false"
                >
                  <a-select-option v-for="(item, index) in filteredTradeTypes" :key="index" :tt="item">
                    {{ item }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="被委托方" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-select
                  :show-arrow="false"
                  :filter-option="false"
                  :not-found-content="clientFetching ? undefined : null"
                  show-search
                  disabled
                  allow-clear
                  v-decorator="[
                    'trustee_id',
                    {
                      rules: [
                        { required: true, message: '' },
                      ],
                    },
                  ]"
                  placeholder="请输入"
                  @search="this.clientSearch"
                  @change="handleClientChange"
                >
                  <a-spin v-if="clientFetching" slot="notFoundContent" size="small" />
                  <a-select-option v-for="d in clientList" :key="d.id">
                    {{ d.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="提单号" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-input allow-clear v-decorator="['bill_lading_number', {rules: [{required: false, message: '必填项，请填写信息'}, {max:32, message: '输入超出长度限制'}]}]" placeholder="请输入"/>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="收费标准" :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-textarea v-decorator="['charging_standard', {rules: [{required: false, message: '必填项，请填写信息'}, ]}]" placeholder="请输入" :rows="4"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form-item v-bind="buttonCol">
            <a-row>
              <a-col offset="8" span="6">
                <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
              </a-col>
              <a-col span="10">
                <a-button @click="handleGoBack">返回</a-button>
              </a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </div>
    </a-card>
  </a-spin>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import debounce from 'lodash/debounce'
import {
  customs_declaration_contract_list,
  customs_declaration_contract_update
} from '@/api/trade_customs_declaration_contract'
import { client_list } from '@/api/trade_client'
export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    this.clientSearch = debounce(this.handleClientSearch, 800)
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0,
      sell_contract_id: 0,
      type: '12',
      data: {},
      loading: false,
      clientFetching: false,
      clientList: [],
      guarantee_period_start_date: undefined,
      guarantee_period_end_date: undefined,
      fields: ['number', 'import_export_type', 'name', 'trustee_id', 'bill_lading_number', 'charging_standard'],
      guarantee_fields: ['guarantee_method', 'storage_location',
        'collateral', 'pledged_goods', 'guarantee_period', 'collateral_pledged_goods_value', 'registration_method'],
      guaranteeMethodList: this.$Dictionaries.guarantee_method,
      tradeTypeList: this.$Dictionaries.trade_types,
      pricingCurrency: undefined
    }
  },
  mounted () {
    this.loadContract()
  },
  computed: {
    isCommon () {
      return false
    },
    validGuaranteeMethodKeys () {
      return Object.keys(this.guaranteeMethodList).map(Number)
    },
    filteredTradeTypes () {
      return Object.fromEntries(
        Object.entries(this.tradeTypeList).filter(([k]) => ['2', '3'].includes(k))
      )
    }
  },
  methods: {
    moment,
    handleGoBack () {
      // this.$emit('onGoBack')
      this.$router.go(-1)
    },
    loadContract () {
      this.loading = false
      this.fields.push(...this.guarantee_fields)
      customs_declaration_contract_list({ id: this.$route.params.id }).then(res => {
        const list = res.data.entries
        if (list && list.length > 0) {
          this.data = list[0]
          this.id = this.data.id
          this.loadEditInfo(this.data)
          this.handleClientSearch(undefined)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handleClientSearch (value) {
      this.clientFetching = true
      client_list({ name: value, id: this.data.trustee_id }).then(res => {
        if (res.code === 1000) {
          this.clientList = res.data.entries || []
        }
      }).finally(() => {
        this.clientFetching = false
      })
    },
    handleClientChange (value) {
      if (value === undefined) {
        this.handleClientSearch(value)
      }
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        console.log('我要提交接口', values, err)
        if (!err) {
          this.loading = true
          customs_declaration_contract_update(values, this.id).then((res) => {
            if (res.code === 1000) {
              this.handleGoBack()
              console.log(res, '修改成功')
            }
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      console.log(`将加载 ${this} 信息到表单`)
      data.import_export_type = '' + data.import_export_type
      const formData = pick(data, this.fields)
      form.setFieldsValue(formData)
    }
  }
}
</script>
